import { Record } from 'immutable'
import { PhoneType } from './enums'

export interface IPhoneNumber {
  readonly phoneNumber: string
  readonly type: PhoneType
}

const PhoneNumberRecord = Record({
  phoneNumber: '',
  type: PhoneType.OfficeMain,
})

export class PhoneNumber extends PhoneNumberRecord implements IPhoneNumber {
  public static fromJS(initialState?: Partial<IPhoneNumber>) {
    return new PhoneNumber(initialState)
  }

  public readonly phoneNumber: string
  public readonly type: PhoneType

  constructor(initialState?: Partial<PhoneNumber>) {
    initialState ? super(initialState) : super()
  }
}
